class Implementation {
    outputs = {
        $energy: null,
        $protein: null,
    }

    implementation = {
        energy: 0,
        protein: 0,
        rating: 0,
    };

    intervention = {
        energy: 0,
        protein: 0,
    };



    constructor($el) {
        this.$el = $el;
        this.$rating = this.$el.find('[data-implementation="rating"]');
        this.intervention.energy = this.$el.data('energy');
        this.intervention.protein = this.$el.data('protein');

        this.outputs.$energy = this.$el.find('[data-implementation="energy"]');
        this.outputs.$protein = this.$el.find('[data-implementation="protein"]');
        this.init();
    }

    init = () => {
        this.$rating.on('change', this.ratingChangeHandler);
        this.ratingChangeHandler();
    }

    ratingChangeHandler = () => {
        this.implementation.rating = parseFloat(this.$rating.val()).toFixed(2);
        this.implementation.energy = parseFloat(this.implementation.rating * this.intervention.energy).toFixed(0);
        this.implementation.protein = parseFloat(this.implementation.rating * this.intervention.protein).toFixed(0);

        this.outputImplementation();
    }

    outputImplementation = () => {
        this.outputs.$energy.text(this.implementation.energy);
        this.outputs.$protein.text(this.implementation.protein);

        this.$el.trigger('change');
    }
}

export default Implementation;
